import {
  Grid2,
  PaymentFailedDialog,
  PaymentSuccessDowngradeDialog,
  PaymentSuccessUpgradeDialog,
} from '@aibees/shared/components';
import { PlanCard } from '@aibees/shared/features';
import { useResponsive } from '@aibees/shared/hooks';
import { classnames } from '@aibees/shared/utils';
import { Box, CardContent } from '@mui/material';
import { memo } from 'react';
import { FREE_PLAN_CONFIG, USAGE_BASED_PLAN_CONFIG } from './config';
import { usePlanList } from './hooks/use-plan-list';
import * as Styled from './styles';
import * as SX from './sx';
import type { PricingCardsProps as Props } from './types';

export const PricingCards = memo(({ className, yearly }: Props) => {
  const { productCards, isLoading } = usePlanList(yearly);
  const isSmall = useResponsive('down', 'sm');

  return (
    <Styled.Wrapper
      className={classnames('PricingCards', className)}
      sx={SX.root}
      variant="filled"
      color="default"
    >
      <CardContent padding="extra" sx={{ width: '100%' }}>
        <Grid2 container spacing={1} columns={48}>
          <PaymentSuccessDowngradeDialog />
          <PaymentSuccessUpgradeDialog />
          <PaymentFailedDialog />
          {productCards.map(({ product, plans, isFree }) => (
            <Grid2
              key={product.id}
              xs={48}
              sm={isSmall ? 48 : 24}
              md={24}
              lg={12}
              xl={12}
            >
              <Box sx={SX.boxPlan}>
                <PlanCard
                  plans={plans}
                  yearly={yearly}
                  isFree={isFree}
                  title={product.name}
                  config={isFree ? FREE_PLAN_CONFIG : USAGE_BASED_PLAN_CONFIG}
                  isLoading={isLoading}
                  isMostPopular={product.name === 'Builder'}
                />
              </Box>
            </Grid2>
          ))}
        </Grid2>
      </CardContent>
    </Styled.Wrapper>
  );
});

PricingCards.displayName = 'PricingCards';
